import { createContext } from "react";
import type { Session, User } from "@supabase/supabase-js";

export type SessionContextValue = {
  session: Session | null;
  user: User | null;
  loading: boolean;
};

export const SessionContext = createContext<SessionContextValue | null>(null);
